import type { ReactNode } from 'react'
import { Icon } from '@iconify/react'
import styles from './TemplateContentSection.module.css'

export function TemplateContentSection({
  title,
  pending,
  layout = 'stack',
  children,
}: {
  title: string
  pending?: boolean
  layout?: 'stack' | 'paired' | 'about'
  children: ReactNode
}) {
  return (
    <details className={styles.section} open>
      <summary className={styles.summary}>
        <h4>{title}</h4>
        <span
          className={
            pending === undefined
              ? styles.standard
              : pending
                ? styles.pending
                : styles.complete
          }
        >
          {pending === undefined
            ? 'Padrão do modelo'
            : pending
              ? 'Obrigatório · A completar'
              : 'Preenchido'}
        </span>
        <Icon icon="mdi:chevron-down" className={styles.chevron} aria-hidden />
      </summary>
      <div
        className={`${styles.content} ${layout === 'paired' ? styles.paired : layout === 'about' ? styles.about : ''}`}
      >
        {children}
      </div>
    </details>
  )
}
